const publicConfig = {
  googleMapsApiKey: `AIzaSyA2jxWoWm8m5xTCqNLR99WkYBf4wV7Hfs4`,
};

export default publicConfig;
